// src/index.ts
async function _piwa(promiseOrFunction) {
  const isValidInput = typeof promiseOrFunction === "function" || promiseOrFunction instanceof Promise;
  if (!isValidInput) {
    throw new PiwaBadInputError();
  }
  const _promise = promiseOrFunction instanceof Promise ? promiseOrFunction : typeof promiseOrFunction === "function" ? (async () => promiseOrFunction())() : promiseOrFunction;
  return _promise.then((data) => ({ data, error: null })).catch((error) => {
    return {
      error,
      data: null
    };
  });
}
var PiwaBadInputError = class extends Error {
  constructor() {
    super("Piwa only accepts promise, async function, or function");
    this.name = "PiwaBadInputError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
};
var src_default = _piwa;
var pw = _piwa;
var piwa = _piwa;
export {
  PiwaBadInputError,
  src_default as default,
  piwa,
  pw
};
